module.exports = __webpack_public_path__ + "img/Animation_mariage.6c4b7c0.png";